import React from "react";
import { useTranslation } from "react-i18next";

import "../../styles/theme.css";
import "../../styles/dashboard.css";
import "../../styles/ProfilesManager.css";
import "../../styles/helpProfile.css";

export default function Llmprofile() {
  const { t } = useTranslation("help");

  const attackFields = t("Llmprofile.attackObjectFields.rows", {
    returnObjects: true,
    defaultValue: []
  });

  const categories = t("Llmprofile.supportedCategories.rows", {
    returnObjects: true,
    defaultValue: []
  });

  const parameters = t("Llmprofile.commonParameters.rows", {
    returnObjects: true,
    defaultValue: []
  });

  const runtimeArguments = t("Llmprofile.runtimeTargetArguments.rows", {
    returnObjects: true,
    defaultValue: []
  });

  const outcomes = t("Llmprofile.resultInterpretation.outcomes", {
    returnObjects: true,
    defaultValue: []
  });

  const renderTable = (rows, headers, widths = []) => (
    <table className="dark-guide-table">
      <thead>
        <tr>
          {headers.map((header, index) => (
            <th key={index}>{header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {(Array.isArray(rows) ? rows : []).map((row, index) => (
          <tr key={index}>
            {Object.values(row).map((value, valueIndex) => (
              <td key={valueIndex}>{value}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );

  return (
    <div className="theme-whbl">
      <div className="container-fluid">
        <div className="row">
          <main
            style={{
              width: "97%",
              overflowX: "auto"
            }}
          >
            <div className="dashboard">
              <div className="pm-header">
                <div className="pm-title-section">
                  <h1 className="pm-title">
                    {t(
                      "Llmprofile.pageTitle",
                      "Format du fichier d’entrée du testeur d’attaques de modèles d’IA"
                    )}
                  </h1>
                </div>
              </div>

              <div>
                <p>
                  {t(
                    "Llmprofile.introText",
                    "Ce répertoire contient des fichiers JSON contenant uniquement les attaques pour le script de test. Les fichiers d’entrée ne contiennent pas les noms de modèles, les versions d’API, les noms de fournisseurs, les URL ou les clés API. Ces valeurs sont fournies à l’exécution afin que le même fichier de charge d’attaque puisse être réutilisé avec un simulateur local ou des API de modèles d’IA réelles."
                  )}
                </p>

                <h2>
                  {t("Llmprofile.runPatternTitle", "Modèle d’exécution")}
                </h2>

                <p>
                  <strong>
                    {t(
                      "Llmprofile.tlsGuidanceLabel",
                      "Conseils TLS :"
                    )}
                  </strong>{" "}
                  {t("Llmprofile.tlsGuidanceText1", "Utilisez")}{" "}
                  <code>--verify-tls</code>{" "}
                  {t(
                    "Llmprofile.tlsGuidanceText2",
                    "pour les API réelles des fournisseurs d’IA. Utilisez"
                  )}{" "}
                  <code>--no-verify-tls</code>{" "}
                  {t(
                    "Llmprofile.tlsGuidanceText3",
                    "uniquement pour les points de terminaison du simulateur local utilisant des certificats auto-signés."
                  )}
                </p>

                <h2>
                  {t(
                    "Llmprofile.topLevelFileFormatTitle",
                    "Format du fichier de niveau supérieur"
                  )}
                </h2>

                <p>
                  {t(
                    "Llmprofile.preferredFormatText",
                    "Format JSON d’attaque recommandé :"
                  )}
                </p>

                <pre className="attack-json-example">
{`{
  "attacks": [
    {
      "id": "test-001",
      "category": "abuse_misuse",
      "prompt": "Example attack prompt",
      "expect": "blocked",
      "repeat": 1
    }
  ]
}`}
                </pre>

                <p>
                  {t(
                    "Llmprofile.operationalNote",
                    "Remarque opérationnelle : le testeur accepte également un tableau JSON brut d’objets d’attaque, mais le format objet présenté ci-dessus est recommandé."
                  )}
                </p>

                <h2>
                  {t(
                    "Llmprofile.attackObjectFieldsTitle",
                    "Champs de l’objet d’attaque"
                  )}
                </h2>

                {renderTable(
                  attackFields,
                  [
                    t("Llmprofile.tableHeaderField", "Champ"),
                    t("Llmprofile.tableHeaderRequired", "Obligatoire"),
                    t("Llmprofile.tableHeaderType", "Type"),
                    t(
                      "Llmprofile.tableHeaderDescription",
                      "Description"
                    )
                  ]
                )}

                <h2>
                  {t(
                    "Llmprofile.supportedCategoriesTitle",
                    "Catégories prises en charge"
                  )}
                </h2>

                {renderTable(
                  categories,
                  [
                    t("Llmprofile.tableHeaderCategory", "Catégorie"),
                    t("Llmprofile.tableHeaderPurpose", "Objectif")
                  ]
                )}

                <p>
                  {t(
                    "Llmprofile.categoriesAliasesNote1",
                    "Des alias tels que"
                  )}{" "}
                  <code>dos</code>{" "}
                  {t(
                    "Llmprofile.categoriesAliasesNote2",
                    "et"
                  )}{" "}
                  <code>dos_rate_limit</code>{" "}
                  {t(
                    "Llmprofile.categoriesAliasesNote3",
                    "sont acceptés, mais les noms de catégories standard ci-dessus sont préférés."
                  )}
                </p>

                <h2>
                  {t(
                    "Llmprofile.commonParametersTitle",
                    "Paramètres communs"
                  )}
                </h2>

                {renderTable(
                  parameters,
                  [
                    t("Llmprofile.tableHeaderParam", "Paramètre"),
                    t(
                      "Llmprofile.tableHeaderUsedByTester",
                      "Utilisé par le testeur"
                    ),
                    t(
                      "Llmprofile.tableHeaderDescription",
                      "Description"
                    )
                  ]
                )}

                <h2>
                  {t(
                    "Llmprofile.categorySpecificTitle",
                    "Configurations spécifiques aux catégories"
                  )}
                </h2>

                <p>
                  {t(
                    "Llmprofile.categorySpecificText",
                    "La configuration spécifique à une catégorie est fournie via l’objet params lorsqu’une catégorie de test nécessite des métadonnées supplémentaires de requête ou de sécurité."
                  )}
                </p>

                <h2>
                  {t(
                    "Llmprofile.runtimeTargetArgumentsTitle",
                    "Arguments de cible à l’exécution"
                  )}
                </h2>

                {renderTable(
                  runtimeArguments,
                  [
                    t(
                      "Llmprofile.tableHeaderCliArgument",
                      "Argument CLI"
                    ),
                    t(
                      "Llmprofile.tableHeaderDescription",
                      "Description"
                    )
                  ]
                )}

                <h2>
                  {t(
                    "Llmprofile.resultInterpretationTitle",
                    "Interprétation des résultats"
                  )}
                </h2>

                <p>
                  {t(
                    "Llmprofile.resultInterpretationIntro1",
                    "Une requête est considérée comme"
                  )}{" "}
                  <strong>
                    {t(
                      "Llmprofile.resultInterpretationIntro2",
                      "bloquée"
                    )}
                  </strong>{" "}
                  {t(
                    "Llmprofile.resultInterpretationIntro3",
                    "lorsque le testeur observe l’un des résultats suivants :"
                  )}
                </p>

                <ul>
                  {(Array.isArray(outcomes) ? outcomes : []).map(
                    (outcome, index) => (
                      <li key={index}>{outcome}</li>
                    )
                  )}
                </ul>
              </div>
            </div>
          </main>
        </div>
      </div>

      <style>{`
        .dark-guide-table {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed;
          font-family: "Segoe UI", Arial, sans-serif;
          font-size: 14px;
          color: #e5e7eb;
          background: #111827;
          border: 1px solid #374151;
          margin: 18px 0 28px;
        }

        .dark-guide-table thead th {
          background: #1f2937;
          color: #60a5fa;
          font-weight: 700;
          text-align: left;
          padding: 12px 14px;
          border: 1px solid #4b5563;
          vertical-align: middle;
        }

        .dark-guide-table tbody td {
          background: #111827;
          color: #e5e7eb;
          padding: 12px 14px;
          border: 1px solid #374151;
          vertical-align: top;
          line-height: 1.55;
          word-break: break-word;
        }

        .dark-guide-table tbody tr:nth-child(even) td {
          background: #172033;
        }

        .dark-guide-table tbody tr:hover td {
          background: #1e293b;
        }

        .attack-json-example {
          width: 100%;
          box-sizing: border-box;
          padding: 16px;
          margin: 15px 0 20px;
          overflow-x: auto;
          background: #0f172a;
          border: 1px solid #374151;
          color: #e5e7eb;
          border-radius: 4px;
          font-family: Consolas, "Courier New", monospace;
          font-size: 14px;
          line-height: 1.55;
        }

        code {
          color: #93c5fd;
        }

        h2 {
          margin-top: 28px;
          margin-bottom: 12px;
        }

        @media (max-width: 768px) {
          .dark-guide-table {
            min-width: 750px;
          }
        }
      `}</style>
    </div>
  );
}
